import { createContext, useState } from "react";

export const CrimeContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [crimes, setCrimes] = useState([]);

    // Make the context object:
    const crimeContext = {
        crimes,
        setCrimes,
    };

    // pass the value in provider and return
    return <CrimeContext.Provider value={crimeContext}>{children}</CrimeContext.Provider>;
};

export const { Consumer } = CrimeContext;
